var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Gauge',_vm._b({attrs:{"score":_vm.score,"item-id":_vm.itemId,"title":_vm.title,"request-status":_vm.requestStatus},on:{"reload":_vm.getData}},'Gauge',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }